module.exports = __webpack_public_path__ + "media/09.3109b3bd.mp4";